<template>
  <div>
    <!-- Page Header -->
    <div class="mb-5">
      <div class="headline saPrimary--text">
        {{ $t("company.dashboard.title") }}
      </div>
      <span class="body-1 greyDarken3--text">{{
        $t("company.dashboard.subtitle")
      }}</span>
    </div>

    <!-- Page Content -->
    <div>
      <v-layout v-if="summary" row wrap>
        <!-- Organizations -->
        <v-flex xs12 sm12 md3 py-2 pr-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_companies }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("screener.organizations.title") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.rms_bank</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >
        <!-- Movies -->
        <v-flex xs12 sm12 md3 pa-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_films }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("screener.movies.title") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.rms_movie</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >
        <!-- Screenings -->
        <v-flex xs12 sm12 md3 pa-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_screenings }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("screener.title") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.rms_film</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >
        <!-- Participants -->
        <v-flex xs12 sm12 md3 py-2 pl-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_participants }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("company.participants.list.title") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.rms_company_members</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >

        <!-- Passes -->
        <v-flex xs12 sm12 md3 py-2 pr-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_hybrid_events }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("screener.title.hybrid_events") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.rms_group</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >

        <!-- Coupons -->
        <v-flex xs12 sm12 md3 pa-2>
          <v-card class="pa-3">
            <v-layout row wrap>
              <v-flex xs9>
                <div class="display-2">{{ summary.total_inperson_events }}</div>
                <div class="subheading saSecondary--text">
                  {{ $t("screener.title.inperson_events") }}
                </div>
              </v-flex>
              <v-flex xs3
                ><v-layout fill-height justify-center align-center
                  ><v-icon color="saSecondary" size="50"
                    >$vuetify.icons.mew_theater</v-icon
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card></v-flex
        >
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "AdminDashboard",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getDashboardSummary();
    });
  },
  data() {
    return {
      summary: null,
    };
  },
  methods: {
    async getDashboardSummary() {
      try {
        var response = await this.$store.dispatch(
          "adminDashboard/getSummary",
          {}
        );
        this.summary = response.data;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
  },
};
</script>
